interface FileObject {
  size: number;
}

const isOverSize = (files: FileObject[], maxSize: number): boolean =>
  files.reduce((acc, { size }) => acc + size, 0) > maxSize;

export default isOverSize;
